import { useContext } from 'react';
import WidgetContext from '../contexts/WidgetContext';
export default function useWidgetContext() {
    const widgetContext = useContext(WidgetContext);
    if (!widgetContext) {
        throw new Error('Widget context not found');
    }
    if (!widgetContext[0] || !widgetContext[1]) {
        throw new Error('Incomplete react widget context.');
    }
    return { configuration: widgetContext[0], eventContainer: widgetContext[1] };
}
//# sourceMappingURL=useWidgetContext.js.map